export const qaNotes = {
  qaNoteUpdateError: "Error updating the QA note, please try again"
};
